import initOrderForm from '../shared/orderForm';
import initAccordions from './accordion';
import initValuationTabs from './tabs';

interface ValuationConfig {
  content: {
    order: Parameters<typeof initOrderForm>[0]['content'];
  };
  valuation: {
    slider: string;
  };
}

export default ({
  content,
  valuation
}: ValuationConfig): void => {
  initAccordions();
  initValuationTabs(valuation.slider);

  const onSuccess = () => {
    if (typeof gtag === 'function') {
      gtag('event', 'send_request', { event_category: 'valuation' });
    }
  };

  initOrderForm({
    content: content.order,
    onSuccess
  });
};
